import React from "react"
import { DropdownTrigger } from "packages/ui-shared/components/Dropdown/Trigger/Trigger"
import { styledContainer, styledLabel } from "./Sort.css"

type Props = {
  onChange: (value: string) => void
  sortOptions: { value: string; label: string }[]
  defaultValue: { value: string; label: string }
}

export const Sort: React.FC<Props> = ({
  onChange,
  sortOptions,
  defaultValue,
}) => {
  return (
    <div className={styledContainer}>
      <p className={styledLabel}>Sort by</p>
      <DropdownTrigger
        ariaLabel="Sort by"
        onChange={onChange}
        options={sortOptions}
        preselectedOption={defaultValue}
      />
    </div>
  )
}
